import React from "react";
import { Link } from "gatsby";
import Layout from "../../components/layout";
import Navbar from "../../components/navbar-nonhome";
import { css } from "@emotion/react";
import { MdCheck } from "react-icons/md";
import GoogleMap from "google-map-react";

import { Helmet } from "react-helmet";

const styleh1 = {
	fontSize: "2.8rem",
	lineHeight: "3.2rem",
	fontWeight: "500",
	color: "var(--text-color)",
	paddingTop: "2rem",
	paddingBottom: "4rem",
};

const styleh2 = {
	fontSize: "2rem",
	lineHeight: "2.8rem",
	fontWeight: "400",
	paddingTop: "3rem",
	paddingBottom: "1rem",
};

export default function AsbestAfvoeren() {
	return (
		<Layout>
			<Helmet
				titleTemplate="%s | Asbest Verwijderen | Asbest Saneren | De Nr 1 Expert in België | Asbitech"
				htmlAttributes={{
					lang: `nl`,
				}}
			>
				<title>Asbestsanering</title>
				<meta name="format-detection" content="telephone=yes"></meta>
				<meta
					name="description"
					content="Een veilige asbestsanering van uw gebouw of project vindt u bij onze specialisten uit Willebroek. Ontdek hoe we te werk gaan en maak een afspraak."
				/>
				<meta
					property="og:description"
					content="Een veilige asbestsanering van uw gebouw of project vindt u bij onze specialisten uit Willebroek. Ontdek hoe we te werk gaan en maak een afspraak."
				/>
			</Helmet>
			<Navbar />
			<div className="headerpadding" />
			<div
				className="mobile"
				css={css`
					max-width: 1000px;
					margin: auto auto;
					padding-bottom: 4rem;
				`}
			>
				<h1 style={styleh1}>Asbestsanering</h1>
				<ul
					className="ul-grizzly"
					style={{
						listStyle: "none",
						padding: "0",
						display: "flex",
						width: "100%",
						justifyContent: "space-between",
					}}
				>
					<li style={{ float: "left", margin: "0" }}>
						<MdCheck size="2rem" fill="var(--accent-color)" />{" "}
						<strong>Voor particulieren én ondernemers</strong>
					</li>
					<li style={{ float: "left" }}>
						<MdCheck size="2rem" fill="var(--accent-color)" />{" "}
						<strong>Kleine en grote saneringen</strong>
					</li>
					<li style={{ float: "left" }}>
						<MdCheck size="2rem" fill="var(--accent-color)" />{" "}
						<strong>Ervaring in petrochemie en civiele bouw</strong>
					</li>
				</ul>
				<p>
					Voor een veilige asbestsanering van uw gebouw moet u bij ons bedrijf
					zijn. Asbitech uit Willebroek, nabij Mechelen, heeft jarenlange
					ervaring met het saneren van asbest. In 2020 saneerden wij maar liefst
					228 ton losgebonden asbest voor 164 tevreden klanten. Wordt u onze
					volgende tevreden klant?
				</p>
				<h2 style={styleh2}>Wilt u ons inschakelen als asbestverwijderaar?</h2>
				<Link to="/contact">
					<button>Vraag direct een offerte aan</button>
				</Link>
			</div>

			<div
				css={css`
					width: 100%;
					background-color: var(--text-color);
				`}
			>
				<div
					css={css`
						max-width: 1000px;
						margin: auto auto;
						padding-bottom: 4rem;
						color: var(--background-color);
						padding-top: 2rem;
					`}
				>
					<h2 className="mobile" style={styleh2}>
						Maak gebruik van onze veilige asbestsanering
					</h2>
					<div className="mobile p-grizzly">
						<p>
							Zoals ondertussen is geweten, is asbest een zeer gevaarlijke stof.
							Bij inademing kan u gezondheidsproblemen oplopen op lange termijn.
							Daarom is het van groot belang dat de asbestsanering op een
							veilige manier gebeurt. Als erkende asbestverwijderaars garanderen
							we u dat het saneren van asbest bij ons altijd veilig gebeurt, of
							het nu gaat om{" "}
							<Link to="/asbestsanering/asbestdaken-verwijderen-brussel">
								het verwijderen van asbestdaken
							</Link>{" "}
							of een gehele sanering. Hoe garanderen we die veiligheid? We
							overleggen steeds met gespecialiseerde adviseurs op het gebied van
							gezondheid en veiligheid zodat alles veilig is zowel voor onze
							medewerkers als voor de omgeving. Aan de hand van het advies
							bepalen we <Link to="/diensten">welke methode</Link> het meest
							geschikt is om het asbest te saneren.
						</p>
					</div>

					<div
						css={css`
							display: flex;
							margin-top: 3rem;
						`}
					>
						<div className="timeline">
							<div className="circle" />1
						</div>
						<div className="timeline">
							<div className="circle" />2
						</div>
						<div className="timeline">
							<div className="circle" />3
						</div>
						<div className="timeline">
							<div className="circle" />4
						</div>
					</div>
					<div
						css={css`
							display: flex;
						`}
					>
						<div className="timelinetext">Neem contact op</div>
						<div className="timelinetext">Vrijblijvende offerte</div>
						<div className="timelinetext">Asbest verwijderen</div>
						<div className="timelinetext">Uw attest</div>
					</div>
					<div
						css={css`
							text-align: center;
							margin-top: 3rem;
						`}
					>
						<Link to="/contact">
							<button>Vraag een offerte aan</button>
						</Link>
					</div>
				</div>
			</div>

			<div
				className="mobile"
				css={css`
					max-width: 1000px;
					margin: auto auto;
					padding-bottom: 6rem;
					padding-top: 3rem;
				`}
			>
				<h2 style={styleh2}>
					Wij saneren asbest bij particulieren én bedrijven
				</h2>
				<p>
					U kan bij ons terecht voor{" "}
					<Link to="/asbestsanering/asbest-verwijderen-particulier-brussel">
						het laten verwijderen van asbest als particulier
					</Link>{" "}
					maar ook voor een grootschalig project. De afgelopen jaren voltooiden
					we in honderden woningen een veilige asbestsanering, maar we werkten
					ook aan allerlei grote projecten. We hebben ervaring in allerlei
					sectoren zoals petrochemie, civiele bouw en de openbare sector. Het
					saneren van asbest in het Koninklijk Paleis of de sanering van de
					Abdij van Tongerlo werden bijvoorbeeld uitgevoerd door ons bedrijf.{" "}
				</p>
			</div>

			<div
				css={css`
					width: 100%;
					background-color: var(--text-color);
				`}
			>
				<div
					css={css`
						max-width: 1000px;
						margin: auto auto;
						padding-bottom: 4rem;
						color: var(--background-color);
						padding-top: 2rem;
					`}
				>
					<h2 className="mobile" style={styleh2}>
						Laat de asbestsanering aan ons over
					</h2>
					<div className="mobile p-grizzly">
						<p>
							Bent u particulier en wilt u{" "}
							<Link to="/asbestsanering/asbest-afvoeren">
								asbest laten afvoeren
							</Link>
							? Of zoekt u een bedrijf voor een grootschalige sanering? Ons
							bedrijf uit Willebroek biedt voor beide een oplossing aan. Maak
							een afspraak via het contactformulier, of bel naar{" "}
							<a href="tel:036050363">+32 (0)3 605 03 63</a>. Wij zorgen voor
							een veilige asbestsanering op maat van uw wensen.
						</p>
					</div>

					<div
						css={css`
							display: flex;
							margin-top: 3rem;
						`}
					>
						<div className="timeline">
							<div className="circle" />1
						</div>
						<div className="timeline">
							<div className="circle" />2
						</div>
						<div className="timeline">
							<div className="circle" />3
						</div>
						<div className="timeline">
							<div className="circle" />4
						</div>
					</div>
					<div
						css={css`
							display: flex;
						`}
					>
						<div className="timelinetext">Neem contact op</div>
						<div className="timelinetext">Projectanalyse</div>
						<div className="timelinetext">Offerte</div>
						<div className="timelinetext">Uitvoering werken</div>
					</div>
					<div
						css={css`
							text-align: center;
							margin-top: 3rem;
						`}
					>
						<Link to="/contact">
							<button>Vraag een offerte aan</button>
						</Link>
					</div>
				</div>
			</div>
			<iframe
				src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10027.09755180727!2d4.3493472!3d51.0757147!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6b076da8b05d8d48!2sAsbitech%20BVBA!5e0!3m2!1snl!2snl!4v1639391210684!5m2!1snl!2snl"
				width="100%"
				height="450"
				style={{ border: "0" }}
				allowfullscreen=""
				loading="lazy"
			></iframe>
		</Layout>
	);
}
